import * as React from "react";
import { Switch as MantineSwitch } from "@mantine/core";
import styled, { css } from "styled-components";
const StyledSwitch = styled(MantineSwitch)(
  ({ theme }) => css`
    .mantine-Switch-label {
      font-weight: normal;
      font-size: ${theme.fonts.size.body};
    }
  `
);
const Switch = ({
  "aria-label": ariaLabel = void 0,
  checked,
  className = void 0,
  disabled = void 0,
  id = void 0,
  label = void 0,
  name = void 0,
  onChange,
  style = void 0
}) => /* @__PURE__ */ React.createElement(
  StyledSwitch,
  {
    "aria-label": ariaLabel,
    className,
    checked,
    disabled,
    id,
    label,
    name,
    onChange,
    style
  }
);
export default Switch;
